/**
 * Avatar autogenerado con iniciales sobre un degradado determinista (el mismo nombre da siempre el
 * mismo color), al estilo de las herramientas modernas. Sin imágenes externas: se dibuja con CSS.
 */

function hashCadena(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (Math.imul(h, 31) + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

/** Iniciales: primera letra del primer y último término (o dos del único), en mayúsculas. */
export function iniciales(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "?";
  if (partes.length === 1) return (partes[0] ?? "?").slice(0, 2).toUpperCase();
  const primera = partes[0] ?? "";
  const ultima = partes[partes.length - 1] ?? "";
  return `${primera.charAt(0)}${ultima.charAt(0)}`.toUpperCase();
}

/** El degradado determinista de un nombre (dos matices vivos relacionados). */
export function gradienteDe(nombre: string): string {
  const h = hashCadena(nombre || "?");
  const matiz1 = h % 360;
  const matiz2 = (matiz1 + 35 + (h % 50)) % 360;
  return `linear-gradient(135deg, hsl(${matiz1} 72% 56%), hsl(${matiz2} 76% 46%))`;
}

export function Avatar({
  nombre,
  size = 32,
  title,
  anillo = false,
}: {
  nombre: string;
  size?: number;
  /** Texto del tooltip (por defecto, el nombre). */
  title?: string;
  /** Aro claro alrededor (para superponer avatares, estilo "conectados"). */
  anillo?: boolean;
}) {
  return (
    <span
      title={title ?? nombre}
      aria-label={nombre}
      className="inline-grid flex-none select-none place-items-center rounded-full font-brand font-bold leading-none text-white"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.4),
        background: gradienteDe(nombre),
        boxShadow: anillo
          ? "0 0 0 2px var(--fc-color-surface), 0 1px 3px rgba(0,0,0,0.22)"
          : "0 1px 3px rgba(0,0,0,0.18)",
      }}
    >
      {iniciales(nombre)}
    </span>
  );
}
